"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CommonModule, DeprecatedI18NPipesModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CalloutModule } from '@shared/ui/callout/callout.module';
import { OnlineStatusModule } from '../online-status/online-status.module';
import { AlertComponent } from './alert/alert.component';
import { BudgetComponent } from './budget.component';
import { ButtonComponent } from './button/button.component';
import { ContainerComponent } from './container/container.component';
import { CurrencyComponent } from './currency.component';
import { EllipsisTextComponent } from './ellipsis-text/ellipsis-text.component';
import { EmojiPickerComponent } from './emoji-picker/emoji-picker.component';
import { EmojiPipe } from './emoji/emoji.pipe';
import { FlagComponent } from './flag/flag.component';
import { HighlightTextModule } from './highlight-text/highlight-text.module';
import { IconModule } from './icon/icon.module';
import { ImageThumbnailComponent } from './image-thumbnail/image-thumbnail.component';
import { InputComponent } from './input/input.component';
import { LayoutModule } from './layout/layout.module';
import { LinkModule } from './link/link.module';
import { LocalizedDateFns } from './localized-date-fns.service';
import { MediaObjectModule } from './media-object/media-object.module';
import { ModalModule } from './modal/modal.module';
import { NotificationIndicatorComponent } from './notification-indicator/notification-indicator.component';
import { PictureComponent } from './picture/picture.component';
import { RatingComponent } from './rating/rating.component';
import { RelativeTimeComponent } from './relative-time/relative-time.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { TooltipModule } from './tooltip/tooltip.module';
import { UI_CONFIG } from './ui.config';
import { UserAvatarComponent } from './user-avatar/user-avatar.component';
var UiModule = (function () {
    function UiModule() {
    }
    UiModule_1 = UiModule;
    UiModule.initialize = function (config) {
        return {
            ngModule: UiModule_1,
            providers: [{ provide: UI_CONFIG, useValue: config }, LocalizedDateFns],
        };
    };
    UiModule = UiModule_1 = __decorate([
        NgModule({
            declarations: [
                AlertComponent,
                BudgetComponent,
                ButtonComponent,
                ContainerComponent,
                CurrencyComponent,
                EllipsisTextComponent,
                FlagComponent,
                ImageThumbnailComponent,
                InputComponent,
                NotificationIndicatorComponent,
                PictureComponent,
                RatingComponent,
                RelativeTimeComponent,
                SpinnerComponent,
                UserAvatarComponent,
                EmojiPickerComponent,
                EmojiPipe,
            ],
            exports: [
                AlertComponent,
                BudgetComponent,
                ButtonComponent,
                ContainerComponent,
                CurrencyComponent,
                EllipsisTextComponent,
                FlagComponent,
                HighlightTextModule,
                IconModule,
                ImageThumbnailComponent,
                InputComponent,
                LayoutModule,
                MediaObjectModule,
                NotificationIndicatorComponent,
                OnlineStatusModule,
                PictureComponent,
                RatingComponent,
                RelativeTimeComponent,
                SpinnerComponent,
                UserAvatarComponent,
                LinkModule,
                CalloutModule,
                EmojiPickerComponent,
                EmojiPipe,
                ModalModule,
                TooltipModule,
                UserAvatarComponent,
            ],
            imports: [
                CalloutModule,
                CommonModule,
                DeprecatedI18NPipesModule,
                HighlightTextModule,
                IconModule,
                LayoutModule,
                LinkModule,
                MediaObjectModule,
                ModalModule,
                OnlineStatusModule,
                ReactiveFormsModule,
                RouterModule,
                TooltipModule,
            ],
        })
    ], UiModule);
    return UiModule;
    var UiModule_1;
}());
export { UiModule };



// WEBPACK FOOTER //
// ui.module.js